import { useEffect, useState, useRef } from 'react';

const useMountTransition = (
  shouldBeVisible: boolean,
  unmountDelay: number = 350
) => {
  const [mounted, setMounted] = useState<boolean>(shouldBeVisible);
  const [visible, setVisible] = useState<boolean>(false);
  const removeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (shouldBeVisible) {
      setMounted(true);
      requestAnimationFrame(() => setVisible(true));
    } else {
      setVisible(false);
      if (removeTimeout.current) {
        window.clearTimeout(removeTimeout.current);
      }
      removeTimeout.current = setTimeout(() => {
        setMounted(false);
      }, unmountDelay) as unknown as ReturnType<typeof setTimeout>;
    }

    return () => {
      if (removeTimeout.current) {
        window.clearTimeout(removeTimeout.current);
        removeTimeout.current = null;
      }
    };
  }, [shouldBeVisible, unmountDelay]);

  return { mounted, visible };
};

export default useMountTransition;
